const moveAllLeft = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M7.698 11.4 4.221 7.889l3.397-3.434L6.552 3.4 2.11 7.888l4.522 4.567zm6 0-3.477-3.511 3.397-3.434L12.552 3.4 8.11 7.888l4.522 4.567z"/></svg>',
};

export { moveAllLeft as default };
